import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/Sales/Clients-list/Clients-list";
// ----------------------------------------------------------------------

export default function Clients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList />
      </Container>
    </>
  );
}
